import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const ForgotPasswordDialog = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  return (
    <Button 
      variant="link" 
      className="text-sm text-primary hover:text-primary-dark p-0 h-auto"
      onClick={() => navigate('/reset-password')}
    >
      {language === 'ar' ? 'هل نسيت كلمة المرور؟' : 'Forgot your password?'}
    </Button>
  );
};
